import { disciplinesById } from 'constants/disciplines';

// The All Around leaderboard: one standing per athlete, summing their points
// across the counting disciplines of the segment rather than ranking one.
//
// Segments this is offered on. Scoped deliberately rather than derived from a
// segment flag, because no such flag exists - HasOpen/HasPro/HasChallenger
// describe competition levels, not whether an all around standing is wanted.
// Add a SegmentUID here to switch it on for another segment.
//
//   51 = W27, "(W27) Premier Womens Rodeo 2027"
export const ALL_AROUND_SEGMENT_UIDS = [51];

export const ALL_AROUND_LABEL = 'All Around';

// An athlete has to place in more than one discipline to have an all around
// standing at all, and clear a points floor to be listed. Both carried over
// from the leaderboard on the WCRA WordPress site so the two agree.
export const ALL_AROUND_MIN_DISCIPLINES = 2;
export const ALL_AROUND_MIN_POINTS = 15;

// Disciplines that do not count towards the all around total. They still have
// their own leaderboards and stay in the "You're viewing" list - this only
// keeps them out of the combined standing.
//
// A deliberate difference from the WCRA WordPress leaderboard, which counted
// both. That one dropped goat tying from a single segment, Reliance Ranches
// "VRQ Bonus 2024", and even there only from its row of discipline buttons.
// Excluded here because WCRA asked for it, not to match the old behaviour.
export const ALL_AROUND_EXCLUDED_DISCIPLINE_IDS = [
  disciplinesById.LADIES_POLE_BENDING,
  disciplinesById.LADIES_GOAT_TYING,
];

// The disciplines of a segment that actually feed the all around standing.
// Deduplicated as well as filtered: a repeated id would count once towards the
// number of disciplines an athlete placed in and again in their total, which is
// a wrong leaderboard rather than a visible error.
export const getAllAroundDisciplines = (disciplineIds = []) => [
  ...new Set(
    disciplineIds.filter(
      (id) => !ALL_AROUND_EXCLUDED_DISCIPLINE_IDS.includes(Number(id)),
    ),
  ),
];

export const isAllAroundSegment = (segmentUID) =>
  ALL_AROUND_SEGMENT_UIDS.includes(Number(segmentUID));

// The competition levels whose points are added together.
//
// There is one all around standing, not one per level, because PWR pays a
// single $20,000 bonus to whoever scores most across Pro and Challenger in
// barrels, breakaway, heading and heeling. Two separate boards could not
// answer who that is.
//
// Limited is not in the list and is not an oversight: the bonus does not
// include it, so Limited points do not count even for an athlete who also
// rides Pro or Challenger elsewhere. Limited keeps its own per-discipline
// boards.
//
// Written as literals rather than imported from constants/competitionLevel,
// which would form an import cycle: competitionLevel imports helpers, and
// helpers exports mergeAllAroundLeaderboards, which imports this file. A unit
// test asserts the two stay in step.
export const ALL_AROUND_COMPETITION_LEVELS = ['pro', 'challenger'];
